import Athena1 from '../../media/Athena/athena (1).png'
import Athena2 from '../../media/Athena/athena (2).png'
import Athena3 from '../../media/Athena/athena (3).png'
import Athena4 from '../../media/Athena/athena (4).png'
import Athena5 from '../../media/Athena/athena (5).png'
import Athena6 from '../../media/Athena/athena (6).png'
import Athena7 from '../../media/Athena/athena (7).png'

const images =[
    Athena1,Athena2,Athena3,Athena4,Athena5,Athena6,Athena7
]

export default images;